<script>

    import { toast } from 'bulma-toast'
    import { tipStore, tipsStore, modalStore } from '../stores'

    import TipsService from '../$services/tips.service'

    import Form from '../$components/form.svelte'
    import Textarea from '../$components/textarea.svelte'
    import Button from '../$components/button.svelte'
    import Select from '../$components/select.svelte'

    let loading = false

    let data = {
        _id: $tipStore._id,
        type: $tipStore.type,
        message: $tipStore.message,
    }

    async function updateTip() {
    
        loading = true
        const resp = await TipsService.updateTip($tipStore._id, data)
        loading = false
    
        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})
    
        tipsStore.replace(resp.data)
        modalStore.close()

        toast({message: 'Tip actualizado', type: 'is-success'})
    }

</script>

<Form on:submit={updateTip} { loading } >

    <Select
        bind:value={data.type}
        label="Tipo"
        options={[
            {value: 'tip', text: 'Tip plataforma'},
            {value: 'data', text: 'Dato curioso'},
        ]}
    />

    <Textarea bind:value={data.message} label="Mensaje" />

    <div class="items-end">
        <div class="buttons">
            <Button on:click={modalStore.close} text="Cancelar" icon="ban" color="light"/>
            <Button type="submit" text="Guardar" icon="save" color="primary" {loading}/>
        </div>
    </div>
</Form>